import {
  Avatar,
  Card,
  CardSection,
  Center,
  Group,
  Image,
  Skeleton,
  Stack,
  Text,
  useMantineTheme,
} from '@mantine/core';
import { IconCircleCheck } from '@tabler/icons';
import { IconCircleCheckFilled } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { Database } from '../../types/supabase';

export default function TwitterCard({
  shareImage,
  tierListData,
}: {
  shareImage: string | null;
  tierListData: Database['public']['Tables']['tier_lists']['Row'];
}) {
  const theme = useMantineTheme();
  const ayoTwitter = {
    name: 'The Don Ayo',
    tag: 'TheDonAyo',
    profilePic: 'https://pbs.twimg.com/profile_images/1601795577322291201/pY6DlVFw_400x400.jpg',
  };
  const sethTwitter = {
    name: 'Seth Setse',
    tag: 'SethSetse',
    profilePic: 'https://pbs.twimg.com/profile_images/1202299355962728449/L181FRJ9_400x400.jpg',
  };
  const [currentTwitter, setCurrentTwitter] = useState(ayoTwitter);
  useEffect(() => {
    if (Math.random() > 0.5) {
      setCurrentTwitter(sethTwitter);
    }
  }, []);

  const boldSize = 700;
  return (
    <Card withBorder w="90%" p="sm">
      <Group spacing="xs" sx={{ gap: 0 }}>
        <Card.Section inheritPadding>
          <Group sx={{ gap: 8 }} mb="xs">
            <Avatar src={currentTwitter.profilePic} radius="xl" size="md" />
            <Stack sx={{ gap: 0 }}>
              <Group sx={{ gap: 2 }}>
                <Text fw={boldSize} size="sm">
                  {currentTwitter.name}
                </Text>
                <IconCircleCheck
                  size="1.2rem"
                  color={theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.colors.gray[0]}
                  fill="#1d9cf0"
                />
              </Group>
              <Text fw={boldSize} size="xs" color="dimmed">
                @{currentTwitter.tag}
              </Text>
            </Stack>
          </Group>
          <Text size="md" fw={boldSize}>
            Check out my best {tierListData.name} Tier List!{' '}
            <Text span c="blue" inherit>
              #lomolist
            </Text>
          </Text>
          <Stack
            sx={{
              border: `0.05px solid ${theme.colors.dark[3]}`,
              gap: 0,
              borderRadius: '20px',
              overflow: 'hidden',
            }}
            mt="sm"
            mb="sm"
          >
            <Image
              src={shareImage}
              height={247}
              withPlaceholder
              placeholder={<Skeleton h={247} width="100%" />}
              fit="cover"
              sx={{
                img: {
                  objectPosition: 'left top',
                },
              }}
            />
            <Stack sx={{ padding: '0px 10px 5px 10px', gap: 0 }}>
              <Text
                fw={boldSize}
                size="xs"
                color="dimmed"
                sx={{ lineHeight: '20px', fontSize: '10px' }}
              >
                lomolist.com
              </Text>
              <Text fw={boldSize} size="xs" sx={{ lineHeight: '10px', fontSize: '10px' }}>
                {tierListData.name} | Lomo
              </Text>
              <Text
                fw={boldSize}
                size="xs"
                color="dimmed"
                sx={{ lineHeight: '20px', fontSize: '10px' }}
              >
                {tierListData.description}
              </Text>
            </Stack>
          </Stack>
        </Card.Section>
        <Text fw={boldSize} color="dimmed" size="xs">
          4:20 PM · Jun 9, 2023
        </Text>
      </Group>
    </Card>
  );
}
